import { Link } from 'react-router-dom';

// Components
import RevealFadeIn from '@/components/reveal-animations/RevealFadeIn/RevealFadeIn';
import MixedTitle from '@/components/molecules/MixedTitle/MixedTitle';
import Button from '@/components/atoms/Button/Button';
import Paragraph from '@/components/atoms/Paragraph/Paragraph';

// Utils
import cn from '@/utils/cn';

// Types
import { TextType } from './TextType';

// Styles
import styles from './Text.module.css';

interface TextProps {
  title: TextType['title'];
  paragraph: TextType['paragraph'];
  cta: TextType['cta'];
  align?: 'center' | undefined;
  className?: string;
}

function Text({ title, paragraph, cta = null, align = undefined, className = '' }: TextProps) {
  return (
    <div
      className={cn([
        styles.bloc,
        styles[title.color],
        align ? styles[align] : '',
        title.colorSpan ? styles[title.colorSpan] : null,
        className || '',
      ])}
    >
      <RevealFadeIn>
        <MixedTitle
          title={title.title}
          seoTitleTag={title.seoTitleTag}
          color={title.color}
          colorSpan={title.colorSpan}
          size={title.size}
          sizeSpan={title.sizeSpan}
        />
      </RevealFadeIn>

      <RevealFadeIn delay={0.2}>
        <Paragraph text={paragraph.text} color={paragraph.color} size={paragraph.size} className={styles.text} />
      </RevealFadeIn>

      {cta ? (
        <RevealFadeIn className={styles.action} delay={0.4}>
          <Link to={cta.link}>
            <Button color={cta.color}>{cta.label}</Button>
          </Link>
        </RevealFadeIn>
      ) : null}
    </div>
  );
}

export default Text;
